import React from 'react';
import { AppProvider } from './context/AppContext';
import { ToastProvider } from './context/ToastContext';
import { Header } from './components/layout';
import Dashboard from './components/dashboard/Dashboard';
import './App.css';

function App() {
  return (
    <AppProvider>
      <ToastProvider>
        <div className="min-h-screen bg-gray-50 dark:bg-slate-950">
          <Header connectionStatus="connected" />
          <Dashboard />
        </div>
      </ToastProvider>
    </AppProvider>
  );
}

export default App;
